@if (banner$ | async; as banner) {
    <div class="banner-container" [ngClass]="banner.variant || 'warning'">
        <div class="banner-left">
            <mat-icon class="banner-icon">{{ banner.icon || 'info' }}</mat-icon>
            <div class="banner-content">
                <div class="banner-title">{{ banner.title }}</div>
                <div class="banner-message">{{ banner.message }}</div>
            </div>
        </div>
        <div class="banner-actions">
            <button mat-button color="primary" (click)="dismiss()">
                {{ banner.dismissLabel || 'DISMISS ALERT' }}
            </button>
            @for (action of banner.actions; track action.label) {
                @if (action.variant === 'primary') {
                    <button mat-raised-button color="primary" (click)="onAction(action)">
                        {{ action.label }}
                    </button>
                } @else {
                    <button mat-button (click)="onAction(action)">
                        {{ action.label }}
                    </button>
                }
            }
        </div>
    </div>
}
